const CLIENT_ID: string = import.meta.env.VITE_AUTH_CLIENT_ID;
const ROBCO_STUDIO_URL: string = import.meta.env.VITE_ROBCO_STUDIO_URL;
const AUTH_URL: string = import.meta.env.VITE_AUTH_URL;
const AUTH_LOGIN_PATH: string =
  import.meta.env.VITE_AUTH_LOGIN_PATH || '/login';
const AUTH_LOGOUT_PATH: string =
  import.meta.env.VITE_AUTH_LOGOUT_PATH || '/logout';
const AUTH_SCOPES: string =
  import.meta.env.VITE_AUTH_SCOPES ||
  'aws.cognito.signin.user.admin+email+openid';
const AUTH_LOGOUT_REDIRECT_PARAM: string =
  import.meta.env.VITE_AUTH_LOGOUT_REDIRECT_PARAM || 'redirect_uri';
const AUTH_LOGOUT_INCLUDE_AUTH_PARAMS =
  (import.meta.env.VITE_AUTH_LOGOUT_INCLUDE_AUTH_PARAMS || 'true') === 'true';
const LOGOUT_AUTH_PARAMS = AUTH_LOGOUT_INCLUDE_AUTH_PARAMS
  ? `&response_type=code&scope=${AUTH_SCOPES}`
  : '';
export const REDIRECT_URI = `${ROBCO_STUDIO_URL}/login`;
export const REDIRECT_URL: string = encodeURIComponent(REDIRECT_URI);
export const LOGIN_URL = `${AUTH_URL}${AUTH_LOGIN_PATH}?client_id=${CLIENT_ID}&response_type=code&scope=${AUTH_SCOPES}&redirect_uri=${REDIRECT_URL}`;
export const LOGOUT_URL = `${AUTH_URL}${AUTH_LOGOUT_PATH}?client_id=${CLIENT_ID}${LOGOUT_AUTH_PARAMS}&${AUTH_LOGOUT_REDIRECT_PARAM}=${REDIRECT_URL}`;
export const BASE_URL: string = import.meta.env.VITE_BASE_URL;
export const MODULES_BASE_URL = `${
  import.meta.env.VITE_RESOURCES_BASE_URL
}/modules`;
export const ENVIRONMENTS_BASE_URL = `${
  import.meta.env.VITE_RESOURCES_BASE_URL
}/environments`;
export const DB_BASE_URL = `${import.meta.env.VITE_RESOURCES_BASE_URL}/db`;
export const DEFAULT_DISPLAY_ANGLES = [
  180, 30, -120, -45, -90, 30, -120, 30, 0, 0,
];
export const INFO_ROBCO_BASE_URL = 'https://info.rob.co';
